import CopyButton from "./pixButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import CristoRei from "./assets/CristoRei.png";
import NFG from "./assets/nfg.png";

export const Donations = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const pixMatriz = "03.867.829/0001-84";
  const pixFilial = "03.867.829/0002-65";

  return (
    <div className="bg-gradient-to-br from-slate-900 via-brand-blue to-slate-800 text-white overflow-x-hidden">
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-brand-blue/20 via-transparent to-brand-yellow/20 animate-pulse"></div>
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-brand-yellow/10 rounded-full blur-3xl animate-bounce"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-brand-blue/10 rounded-full blur-3xl animate-pulse"></div>
        </div>
        <div className="relative z-10 text-center max-w-5xl px-4 py-16 md:py-20 animate-fadeInUp">
          <h1
            className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-black font-montserrat mb-4 md:mb-6 bg-gradient-to-r from-white via-brand-yellow to-white bg-clip-text text-transparent animate-pulse"
            style={{ lineHeight: "1.2", paddingTop: "0.25rem" }}
          >
            DOAÇÕES
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-light font-roboto mb-6 md:mb-8 max-w-3xl mx-auto leading-relaxed px-2">
            Sua generosidade transforma vidas. Ajude-nos a continuar nossa
            missão de recuperação e esperança.
          </p>

          {/* Scroll Indicator */}
          <div className="animate-bounce-gentle mb-8">
            <svg
              className="w-8 h-8 text-white/70 hover:text-white transition-colors duration-300 mx-auto"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 14l-7 7m0 0l-7-7m7 7V3"
              />
            </svg>
          </div>
        </div>
      </section>

      {/* Donation Information Section */}
      <section className="py-20 bg-white text-brand-blue">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <div className="text-center lg:text-left">
                <h2 className="text-5xl font-bold font-montserrat mb-8 bg-gradient-to-r from-brand-blue to-brand-yellow bg-clip-text text-transparent">
                  Ajude-nos a transformar vidas!
                </h2>
                <p className="text-xl font-roboto text-gray-700 leading-relaxed mb-6">
                  A Comunidade Terapêutica PATRE clama por sua generosidade em
                  prol daqueles que mais precisam. Nosso compromisso é auxiliar
                  os dependentes químicos e suas famílias a conquistarem uma
                  nova chance na vida, libertando-os do vício e fornecendo
                  suporte emocional, físico e psicológico.
                </p>
                <p className="text-xl font-roboto text-gray-700 leading-relaxed">
                  Cada doação que você faz se torna um raio de esperança para
                  aquelas pessoas que enfrentam batalhas contra a dependência
                  química. Contamos com sua ajuda para continuar nossa missão!
                </p>
              </div>

              <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-6 rounded-3xl shadow-xl">
                <div className="flex items-center justify-center lg:justify-start space-x-4">
                  <a
                    href="https://wa.me/5554996998885?text=Ol%C3%A1%2C%20vim%20pelo%20site%20da%20Comunidade%20Terap%C3%AAutica%20Cristo%20Rei%20PATRE%20e%20gostaria%20de%20saber%20mais%20sobre%20o%20tratamento."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center space-x-3 text-brand-blue hover:text-brand-yellow transition-colors duration-300"
                  >
                    <FontAwesomeIcon icon={faWhatsapp} className="text-3xl" />
                    <span className="text-lg font-semibold">
                      Dúvidas: (54) 99699-8885
                    </span>
                  </a>
                </div>
              </div>

              <div className="text-center lg:text-left">
                <img
                  src={CristoRei}
                  alt="Cristo Rei"
                  className="mx-auto w-32 h-auto"
                />
              </div>
            </div>

            {/* Payment Methods Section */}
            <div className="space-y-8">
              {/* Banrisul Account */}
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-3xl shadow-xl border border-blue-200">
                <h3 className="text-2xl font-bold font-montserrat text-center mb-4 text-blue-800">
                  BANRISUL - MATRIZ
                </h3>
                <div className="text-center text-blue-700 font-roboto">
                  <p className="font-semibold mb-2">
                    ASSOCIAÇÃO AMOR EXIGENTE DE ANTÔNIO PRADO
                  </p>
                  <p className="mb-1">CNPJ: {pixMatriz}</p>
                  <p>AG: 0520 | C/C: 0602343605</p>
                </div>
              </div>

              {/* Sicredi Account */}
              <div className="bg-gradient-to-br from-green-50 to-green-100 p-8 rounded-3xl shadow-xl border border-green-200">
                <h3 className="text-2xl font-bold font-montserrat text-center mb-4 text-green-800">
                  SICREDI - FILIAL
                </h3>
                <div className="text-center text-green-700 font-roboto">
                  <p className="font-semibold mb-2">
                    ASSOCIAÇÃO AMOR EXIGENTE DE ANTÔNIO PRADO
                  </p>
                  <p className="mb-1">CNPJ: {pixFilial}</p>
                  <p>AG: 0259 | C/C: 34713-2</p>
                </div>
              </div>

              {/* PIX Section */}
              <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 p-8 rounded-3xl shadow-xl border border-yellow-200">
                <h3 className="text-2xl font-bold font-montserrat text-center mb-6 text-yellow-800">
                  DOAÇÃO VIA PIX
                </h3>
                <div className="space-y-4">
                  <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <CopyButton text={pixMatriz} />
                    <CopyButton text={pixFilial} />
                  </div>
                  <p className="text-center text-yellow-700 font-roboto text-sm">
                    Copie o CNPJ e doe via PIX
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* NFG Program Section */}
      <section className="py-20 bg-gradient-to-r from-slate-800 to-slate-900">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <div className="bg-gradient-to-br from-slate-700/50 to-transparent p-12 rounded-3xl border border-slate-600 shadow-2xl">
            <img
              src={NFG}
              alt="Nota Fiscal Gaúcha"
              className="w-48 h-auto mx-auto mb-8"
            />
            <h2 className="text-4xl font-bold font-montserrat mb-6 bg-gradient-to-r from-brand-yellow to-white bg-clip-text text-transparent">
              Programa Nota Fiscal Gaúcha
            </h2>
            <p className="text-xl font-roboto text-gray-300 leading-relaxed mb-8">
              Indique a PATRE como entidade beneficiada no Programa NFG. Nós
              ganhamos recursos para continuar salvando vidas e você concorre a
              muitos prêmios todo mês.
            </p>
            <a
              href="https://nfg.sefaz.rs.gov.br/Cadastro/CadastroNfg_1.aspx"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-gradient-to-r from-brand-yellow to-yellow-400 text-brand-blue font-bold font-montserrat py-4 px-10 rounded-full text-xl uppercase tracking-wider shadow-2xl hover:shadow-yellow-400/50 transform hover:scale-110 transition-all duration-500"
            >
              Saiba Mais
            </a>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="py-20 bg-gradient-to-r from-brand-blue to-brand-yellow text-white">
        <div className="max-w-5xl mx-auto text-center px-4">
          <h2 className="text-5xl font-bold font-montserrat mb-8 animate-pulse">
            Sua Doação Faz a Diferença
          </h2>
          <p className="text-2xl font-roboto mb-12 max-w-3xl mx-auto leading-relaxed">
            Cada contribuição, por menor que seja, nos ajuda a oferecer
            tratamento, alimentação, moradia e suporte psicológico para aqueles
            que mais precisam.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <a
              href="https://wa.me/5554996998885?text=Ol%C3%A1%2C%20vim%20pelo%20site%20da%20Comunidade%20Terap%C3%AAutica%20Cristo%20Rei%20PATRE%20e%20gostaria%20de%20saber%20mais%20sobre%20o%20tratamento."
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-brand-blue font-bold font-montserrat py-5 px-12 rounded-full text-xl uppercase tracking-wider shadow-2xl hover:shadow-white/50 transform hover:scale-110 transition-all duration-500"
            >
              Fazer Doação
            </a>
            <a
              href="#quemSomos"
              onClick={() => scrollToSection("quemSomos")}
              className="border-2 border-white text-white font-bold font-montserrat py-5 px-12 rounded-full text-xl uppercase tracking-wider hover:bg-white hover:text-brand-blue transition-all duration-500"
            >
              Conheça Nossa Missão
            </a>
          </div>
        </div>
      </section>

      {/* Back to Top Button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="hidden md:fixed bottom-8 right-8 bg-gradient-to-r from-brand-blue to-brand-yellow text-white p-4 rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-110 transition-all duration-500 z-50 group"
        aria-label="Voltar ao topo"
      >
        <svg
          className="w-6 h-6 transform group-hover:-translate-y-1 transition-transform duration-300"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 10l7-7m0 0l7 7m-7-7v18"
          />
        </svg>
      </button>
    </div>
  );
};
